// DON'T ASK WHY THIS IS NEEDED, BUT IT IS
export function EmptyRefGuid() {
  return "00000000-0000-0000-0000-000000000000";
}
